import { ShowFrontendMenu } from '../types/user';

export function findIsAccess(showFrond: ShowFrontendMenu[] | undefined, itemName: string) {
  return showFrond?.find((item) => item.name === itemName);
}
